import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/service-request-item-step";

export const getServiceRequestItemWithServiceSteps = (id) =>
  axios.get(API_PATH + "/sri-with-service-steps/" + id);

export const getMultipleServiceRequestItemWithServiceSteps = (obj) =>
  axios.post(API_PATH + "/multiple-sri-with-service-steps", obj);

export const saveServiceRequestItemWithSteps = (obj) =>
  axios.post(API_PATH + "/save-sri-with-steps", obj);

export const saveMultipleServiceRequestItemWithSteps = (obj) =>
  axios.post(API_PATH + "/save-multiple-sri-with-steps", obj);

export const cancelReceiveTreatment = (id) =>
  axios.delete(API_PATH + "/cancel-receive-treatment/" + id);

export const cancelReceiveMultipleTreatments = (ids) =>
  axios.post(API_PATH + "/cancel-receive-multiple-treatments", ids);

export const saveServiceRequestItemWithStepsAfterComplete = (obj) =>
  axios.post(API_PATH + "/save-sri-with-steps-after-complete", obj);

export const updateMutiplSriWthParticipantsAndImages = (obj) =>
  axios.post(API_PATH + "/update-mutipl-sri-with-participants-and-images", obj);
